import React from "react";
import compose from "recompose/compose";
import PropTypes from "prop-types";
import withWidth, { isWidthUp } from "material-ui/utils/withWidth";
import Search from "material-ui-icons/Search";
import { fade } from "material-ui/styles/colorManipulator";
import { withStyles } from "material-ui/styles";
import { ListSubheader } from "material-ui/List";
import Autosuggest from "react-autosuggest";
import Paper from "material-ui/Paper";
import SuggestionContainer from "./SuggestionContainer";
import { grey } from "material-ui/colors";
import AccountStatusFilterButtons from "./AccountStatusFilterButtons";
import AccountPaymentMethodFilterButtons from "./AccountPaymentMethodFilterButtons";

const AppBarSearch = props => {
  const {
    classes,
    width,
    suggestions,
    onSuggestionsFetchRequested,
    onSuggestionsClearRequested,
    inputValue,
    setInputValue
  } = props;

  if (!isWidthUp("sm", width)) {
    return null;
  }

  const getSectionSuggestions = section => {
    return section.suggestions;
  };

  const renderSectionTitle = section => {
    return (
      <ListSubheader className={classes.subheader}>
        {section.title}
      </ListSubheader>
    );
  };

  const getSuggestionValue = suggestion => {
    return "";
  };

  const renderSuggestion = suggestion => {
    if (suggestion.type === "accountStatus") {
      return <AccountStatusFilterButtons />;
    }
    if (suggestion.type === "paymentMethod") {
      return <AccountPaymentMethodFilterButtons />;
    }

    return <SuggestionContainer suggestion={suggestion} />;
  };

  const renderSuggestionsContainer = options => {
    const { containerProps, children } = options;
    return <Paper {...containerProps}>{children}</Paper>;
  };

  const shouldRenderSuggestions = value => {
    return true;
  };

  return (
    <div className={classes.wrapper}>
      <Search className={classes.search} />
      <Autosuggest
        theme={{
          container: classes.container,
          suggestionsContainerOpen: classes.suggestionsContainerOpen,
          suggestionsContainer: classes.suggestionsContainer,
          suggestionsList: classes.suggestionsList,
          suggestion: classes.suggestion
        }}
        renderSuggestionsContainer={renderSuggestionsContainer}
        multiSection={true}
        suggestions={suggestions}
        shouldRenderSuggestions={shouldRenderSuggestions}
        onSuggestionsFetchRequested={onSuggestionsFetchRequested}
        onSuggestionsClearRequested={onSuggestionsClearRequested}
        getSuggestionValue={getSuggestionValue}
        getSectionSuggestions={getSectionSuggestions}
        renderSuggestion={renderSuggestion}
        renderSectionTitle={renderSectionTitle}
        inputProps={{
          value: inputValue,
          onChange: setInputValue,
          placeholder: "Account, person, status",
          className: classes.input
        }}
      />
    </div>
  );
};

AppBarSearch.propTypes = {
  classes: PropTypes.object.isRequired,
  width: PropTypes.string.isRequired,
  inputValue: PropTypes.string.isRequired,
  suggestions: PropTypes.array,
  setInputValue: PropTypes.func.isRequired,
  onSuggestionsFetchRequested: PropTypes.func.isRequired,
  onSuggestionsClearRequested: PropTypes.func.isRequired
};

const styles = theme => ({
  wrapper: {
    position: "relative",
    borderRadius: 2,
    background: fade(theme.palette.common.white, 0.15),
    "&:hover": {
      background: fade(theme.palette.common.white, 0.25)
    },
    width: 300,
    flexShrink: 0
  },
  search: {
    width: 64,
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  input: {
    font: "inherit",
    padding: 7,
    paddingLeft: 64,
    border: 0,
    display: "block",
    verticalAlign: "middle",
    whiteSpace: "normal",
    background: "none",
    margin: 0,
    color: "inherit",
    "&:focus": {
      outline: 0
    },
    "&::placeholder": {
      color: "rgba(255,255,255,0.3)"
    }
  },
  container: {
    flexGrow: 1,
    position: "relative",
    zIndex: 1
  },
  suggestionsContainerOpen: {
    position: "absolute",
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit * 3,
    right: 0,
    width: 500
  },
  suggestionsContainer: {
    maxHeight: 300,
    overflowY: "auto"
  },
  suggestion: {
    display: "block"
  },
  suggestionsList: {
    margin: 0,
    padding: 0,
    listStyleType: "none"
  },

  subheader: {
    backgroundColor: grey[100]
  }
});

export { AppBarSearch };

export default compose(
  withStyles(styles, { name: "AppBarSearch" }),
  withWidth()
)(AppBarSearch);



// WEBPACK FOOTER //
// ./src/AppBarSearch.js